<template>
  <div class="searchPage">
    <section class="gallery-wrap">
      <div class="container">
        <h1 class="vname">{{ rawData.title }}</h1>
        <p class="desc">{{ rawData.description }}</p>

        <!-- <div class="menu-list">
          <a-list
            :grid="{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4, xl: 4, xxl: 4 }"
            :loading="loading"
            :dataSource="filteredItems"
            :pagination="pagination"
            :key="1"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              class="list-complete-item"
            >
              <Product v-bind:item="item" :key="item.id" />
            </a-list-item>
          </a-list>
        </div> -->

        <Swiper ref="mySwiper" :options="swiperOptions">
          <SwiperSlide v-for="data in filteredItems" :key="data.id">
            <HomePageProduct
              v-bind:item="data"
              :key="data.id"
              v-on:view-product="viewProduct($event)"
            />
          </SwiperSlide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-pagination" slot="pagination"></div>
        </Swiper>
      </div>
    </section>

    <div v-if="popUpOn">
      <ProductPopup
        :item="popupProduct"
        v-on:close-popup="closePopup($event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { ListByIdService } from "../../services/items.service";
import { LocationId } from "../../services/storage.service";
import Product from "../../views/Home/ProductFeature/Product";
import HomePageProduct from "../../views/Home/ProductFeature/HomePageProduct";

import ProductPopup from "../../views/Home/ProductFeature/ProductPopup.vue";

import router from "../../router";

import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "List",
  components: {
    Product,
    Swiper,
    SwiperSlide,
    HomePageProduct,
    ProductPopup,
  },
  props: {
    list_id: String,
  },
  data() {
    return {
      pageName: "",
      showFilterCat: 10,
      loading: true,
      categories: [],
      subCategories: [],
      items: [],
      allItems: [],
      visible1: false,
      currentTag: "",
      typeTag: "",
      pagination: {
        onChange: (page) => {
          // console.log(page);
          window.scrollTo(0, 0);
        },
        pageSize: 20,
      },

      currentCat: "",
      rawData: [],

      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          320: {
            slidesPerView: 2,
            slidesToShow: 2,
            spaceBetween: 30,
          },
        },
      },

      popUpOn: 0,
      popupProduct: [],
    };
  },

  created() {
    // this.checkLocationIdInUrl();

    // let that = this;
    // if (LocationId.getLocationId() === null) {
    //   this.$confirm({
    //     title: "Where are you ordering from?",
    //     okText: "Pokhara",
    //     okType: "primary",
    //     cancelText: "Kathmandu",
    //     onOk() {
    //       that.updateLocationId(2);
    //       that.clearCart();
    //       // router.push("/pkr/c/:slug?");
    //     },
    //     onCancel() {
    //       that.updateLocationId(1);
    //       that.clearCart();
    //       // router.push("/ktm/c/:slug?");
    //     },
    //   });
    // }

    this.checkListId();

    if (this.list_id === "undefined") {
      this.checkParams();
    }

    this.clearVariables();

    this.currentTag = this.currentTag.toLowerCase();

    if (LocationId.getLocationId() === null) {
      return;
    } else {
      this.loadServices();
    }
  },
  watch: {
    $route: function (n, o) {
      this.checkListId();

      if (this.list_id === "undefined") {
        this.checkParams();
      }

      this.checkParams();
      this.loadServices();
      this.clearVariables();
    },

    locationId: function (newLocationId, oldLocationId) {
      this.loadServices();
    },
  },
  computed: {
    ...mapGetters(["locationId"]),
    filteredItems: function () {
      var filter = this.currentTag.toLowerCase();
      if (filter === "combo") {
        return this.items.filter(function (item) {
          return item.item_type.toLowerCase().indexOf(filter) !== -1;
        });
      } else {
        return this.items.filter(function (item) {
          return item.cat_id.toLowerCase().indexOf(filter) !== -1;
        });
      }
    },
    emptyCategoryList: function () {
      return this.categories.filter(function (item) {
        return item.cat_id !== "";
      });
    },
    emptySubCategoryList: function () {
      let a = this;
      return this.categories.filter(function (item) {
        return item.name == a.currentTag;
      });
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    ...mapActions(["setMinOrder", "updateLocationId", "clearCart"]),

    showFilter() {
      this.visible1 = true;
    },
    onClose() {
      this.visible1 = false;
    },
    handleChange(value) {
      return;
    },
    handleBlur() {
      return;
    },
    handleFocus() {
      return;
    },
    onSearch(e) {
      this.currentTag = "";
      this.typeTag = "";
      this.items = this.allItems.filter((item) =>
        item.name.toLowerCase().includes(e.target.value.toLowerCase())
      );

      if (e.target.value.length > 0) {
        this.showFilterCat = 0;
      } else {
        this.showFilterCat = 1;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterTags: function (tag) {
      this.items = this.allItems;
      this.currentTag = tag;
      this.typeTag = "";

      this.showFilterCat = 0;
    },
    filterTags2: function (tag) {
      this.items = this.allItems;

      this.typeTag = "";
      // this.showFilterCat = 0;
      this.currentCat = tag;
      this.secondFilter(tag);
    },
    secondFilter: function (tag) {
      this.typeTag = tag;
      if (tag === "") {
        this.items = this.allItems;
      } else {
        this.items = this.allItems.filter((item) => item.sub_cat_id === tag);
      }

      this.showFilterCat = 0;
    },

    checkListId: function () {
      if (this.list_id !== "undefined") {
        this.pageName = this.list_id;
      }
    },

    checkParams: function () {
      //  console.log("::" + this.$route.params.slug )
      this.pageName = this.$route.params.slug;

      if (this.$route.params.slug != undefined) {
        this.hasV = 1;
        //if Number
        if (!isNaN(this.vName)) {
          // console.log("Number : " + Number(this.vName));
        }
        // endif NaN
        //if String
        else {
          // console.log("String : " + this.vName)
        }
        // end isnan strings
      } else {
        this.hasV = 0;
        if (LocationId.getLocationId() == 1) {
          router.push("/ktm");
        } else if (LocationId.getLocationId() == 2) {
          router.push("/pkr");
        }
      }
    },

    loadServices: function () {
      ListByIdService.getItems(
        parseInt(LocationId.getLocationId()),
        this.pageName,
        1
      )
        .then((data) => {
          (this.rawData = data),
            (this.items = data.data),
            (this.allItems = data.data),
            (this.loading = false);
        })
        .catch((err) => console.log(err));
    },

    clearVariables: function () {
      this.currentCat = "";
      this.currentTag = "";
      this.typeTag = "";
    },

    checkLocationIdInUrl: function () {
      if (this.$route.params.loc == "ktm") {
        this.updateLocationId(1);
      } else if (this.$route.params.loc == "pkr") {
        this.updateLocationId(2);
      }
    },

    viewProduct(product) {
      this.popupProduct = product;
      this.popUpOn = 1;
    },

    closePopup() {
      this.popUpOn = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.gallery-wrap {
  padding-top: 0px !important;
}

.ant-spin-dot {
  font-size: 50px;
  width: 50px;
  height: 50px;
  i {
    width: 25px;
    height: 25px;
  }
}

.gallery-wrap {
  .item-search {
    width: 300px !important;
    input {
      padding: 5px 20px;
      padding-right: 50px;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      border-radius: 100px;
      border-color: #b1b1b1;
      color: #999999;
      &::-webkit-input-placeholder {
        color: #999999;
      }
    }
    .ant-input-suffix {
      right: 20px;
      i {
        font-size: 18px;
      }
    }
  }
}

.menu-list {
  margin-top: 50px;
}

.menu-list-content {
  .filter-part {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    font-family: $main-font;
    margin: 30px 0 70px;
    .filter {
      cursor: pointer;
      i {
        padding-right: 8px;
      }
      font-size: 16px;
      color: #282828;
      font-weight: 500;
      margin-right: 40px;
    }
    .sort {
      font-size: 16px;
      color: #8b8b99;
      display: inline-block;
      .ant-select {
        margin-left: 10px;
      }
    }
  }
}

.filter-content {
  padding: 15px 80px 60px;
  .cross {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    .img-wrap {
      width: 18px;
    }
  }
}

.demo {
  .button-group {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 0px;
    button {
      height: 30px;
      margin-bottom: 10px;
      line-height: 28px;
      border: 1px solid #e7e9f3;
      font-size: 13px;
      font-weight: 600;
      border-radius: 30px;
      -moz-background-clip: padding;
      -webkit-background-clip: padding-box;
      background-clip: padding-box;
      padding: 0 20px;
      text-transform: uppercase;
      background-color: transparent;
      -ms-transition: all 500ms ease;
      -webkit-transition: all 500ms ease;
      transition: all 500ms ease;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: #fff;
        background-color: $brand-color;
      }
      &:hover {
        color: #fff;
        background-color: $brand-color;
      }
      &:focus {
        outline: none;
      }
    }
    &.secondary-filter {
      padding-top: 15px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        top: 0;
        width: 65%;
        height: 1px;
        background: #eaeaea;
        transform: translate3d(-50%, 0, 0);
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .gallery-wrap {
    .item-search {
      input {
        height: 38px;
        line-height: 38px;
      }
    }
  }
  .menu-list-content {
    .filter-part {
      .sort {
        margin-top: 13px;
      }
    }
  }
  .filter-content {
    padding: 15px 20px 30px;
  }
}
@media only screen and (max-width: 575px) {
  .gallery-wrap {
    .item-search {
      margin-bottom: 20px;
      input {
        height: 35px;
        line-height: 35px;
      }
    }
  }
  .menu-list {
    max-width: 350px;
    margin: 50px auto 0;
  }
  .menu-list-content {
    .filter-part {
      margin: 15px 0 50px;
      .filter {
        margin-right: 20px;
        font-size: 14px;
      }
      .sort {
        margin: 0;
        .info {
          display: none;
        }
        .ant-select {
          margin-left: 0;
          width: 150px !important;
        }
      }
    }
  }
  .demo {
    .button-group {
      button {
        height: 28px;
        line-height: 20px;
        font-size: 12px;
        margin-right: 10px;
        padding: 0 15px;
        text-transform: capitalize;
      }
    }
  }
}
@media only screen and (max-width: 425px) {
  .gallery-wrap {
    .item-search {
      width: 100% !important;
      max-width: 250px;
    }
  }
  .menu-list-content {
    .filter-part {
      margin: 10px 0 40px;
      .filter {
        margin-right: 0px;
      }
    }
  }
  .filter-content {
    padding: 15px 10px 15px;
  }
}

.tagBtn button {
  height: inherit !important;
  border: none !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border-radius: 0px !important;
  background-clip: padding-box !important;
  padding: 3px 18px !important;
  text-transform: uppercase !important;
  -webkit-transition: all 500ms ease !important;
  transition: all 500ms ease !important;
  margin-right: 0px !important;
  margin-bottom: 7px !important;
  border-right: 1px dashed #ccc !important;
}

.showFilterBar {
  display: block;
  position: relative;
  margin-top: 20px;
  .line {
    border-bottom: 1px dashed #ffffff;
  }
  .text {
    cursor: pointer;
    text-align: center;
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
    padding: 8px 20px;
    margin: 0 auto;
    background: #ed3c3b;
    color: #fff;
    letter-spacing: 2px;
    font-size: 12px;
    border-radius: 200px;
    margin-left: 50%;
    transform: translate(-50%, -50%);
    border: 4px solid #fff;
  }
}
.vname {
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;

  span {
    margin: 0;
    font-size: 15px;
    text-transform: uppercase;
    font-weight: bold;
  }
}

.product {
  .image-wrap {
    border-radius: 10px !important;
  }
}

.filters {
  padding: 30px 0px;
  padding-top: 10px;
  background: #fff;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.2);

  .closeBtn {
    color: rgb(241, 83, 83);
    position: absolute;
    right: 10px;
    top: 10px;
    font-weight: bold;
    cursor: pointer;
  }
}
.searchPage {
  margin-top: 20px !important;
}

p.desc {
  font-style: italic;
  text-align: center;
}

.swiper-button-prev {
  position: absolute;
  top: 50%;
  // width: calc(var(--swiper-navigation-size) / 44 * 27);
  // height: var(--swiper-navigation-size);
  /* margin-top: calc(-1 * var(--swiper-navigation-size) / 2); */
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ec3934;
  left: 0;
  outline: none;
}

.swiper-button-next {
  position: absolute;
  top: 50%;
  // width: calc(var(--swiper-navigation-size) / 44 * 27);
  // height: var(--swiper-navigation-size);
  /* margin-top: calc(-1 * var(--swiper-navigation-size) / 2); */
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ec3934;
  right: 0;
  outline: none;
}

.swiper-button-prev:after {
  font-family: swiper-icons;
  font-size: 26px;
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
  outline: none;
}

.swiper-button-next:after {
  font-family: swiper-icons;
  font-size: 28px;
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
  left: 0;
  outline: none;
}

.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  outline: none;
}

.swiper-pagination-bullet-active {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #ec3934;
  opacity: 1;
  outline: none;
}
</style>
